
const initChangingBackground = () => {
    //const changingPoint = document.querySelector('.js-changing-point');
    const changingPoint = document.getElementById('contact');
    const bgElements = document.querySelectorAll('.js-bg-element');

    if(!changingPoint) return;

    document.addEventListener('scroll', () => {
        const screenBottom = window.scrollY + window.innerHeight;

        if(changingPoint.offsetTop < screenBottom) {
            document.body.classList.add('change-bg');
            bgElements.forEach(bgElement => {
                bgElement.classList.add('change-bg');
            })
        }
        else {
            document.body.classList.remove('change-bg');
            bgElements.forEach(bgElement => {
                bgElement.classList.remove('change-bg');
            })
        }
    })

}

export { initChangingBackground }